import React, { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api } from "../../lib/api";
import { num } from "./PlatformDashboard";

const clip = (s, n) => (s && s.length > n ? `${s.slice(0, n).trimEnd()}…` : s);

export function NotificationPreview({ a }) {
  const [total, setTotal] = useState(null);
  useEffect(() => { api.get("/platform/stats", { params: { days: 1 } }).then((r) => setTotal(r.data?.users_total ?? null)).catch(() => setTotal(null)); }, []);
  return (
    <div className="mt-4" data-testid="notif-preview">
      <div className="rounded-[22px] bg-navy p-3 shadow-inner">
        <div className="rounded-2xl bg-white/95 p-3 shadow-lg backdrop-blur" data-testid="notif-preview-card">
          <div className="flex items-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-md bg-brand text-[10px] font-black text-white">O</span>
            <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Oryntix</span>
            <span className="ml-auto text-[11px] text-slate-400">sekarang</span>
          </div>
          <p className="mt-1.5 text-sm font-bold text-slate-900" data-testid="notif-preview-title">{clip(a.title, 60) || "Judul pengumuman"}</p>
          {a.body && <p className="mt-0.5 text-xs leading-snug text-slate-600" data-testid="notif-preview-body">{clip(a.body.replace(/\s+/g, " "), 120)}</p>}
        </div>
      </div>
      <p className="mt-2 flex items-center gap-1.5 text-xs text-slate-500" data-testid="notif-preview-recipients">
        <Users size={13} /> {total == null ? "Perkiraan penerima tidak tersedia" : <>Perkiraan penerima: <b className="text-slate-800">{num(total)} pengguna</b></>}
      </p>
    </div>
  );
}
